import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { SectorizationByNeighborhoodMonthly } from './SectorizationByNeighborhoodMonthly';

const Sectorization = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <SectorizationByNeighborhoodMonthly />
        </>
    );
};

export default Sectorization;
